import { CalmMetadata } from './metadata.js';
import { CalmControls } from './control.js';
import { CalmNodeInterface } from './interface.js';
export class CalmRelationship {
    constructor(originalJson, uniqueId, relationshipType, metadata, controls, additionalProperties, description, protocol) {
        this.originalJson = originalJson;
        this.uniqueId = uniqueId;
        this.relationshipType = relationshipType;
        this.metadata = metadata;
        this.controls = controls;
        this.additionalProperties = additionalProperties;
        this.description = description;
        this.protocol = protocol;
    }
    toCanonicalSchema() {
        return {
            'unique-id': this.uniqueId,
            'relationship-type': this.relationshipType.toCanonicalSchema(),
            'metadata': this.metadata ? this.metadata.toCanonicalSchema() : undefined,
            'controls': this.controls ? this.controls.toCanonicalSchema() : undefined,
            'description': this.description,
            'protocol': this.protocol,
            ...this.additionalProperties
        };
    }
    toSchema() {
        return this.originalJson;
    }
    static fromSchema(schema) {
        const { 'unique-id': uniqueId, 'description': description, 'relationship-type': relationshipType, 'protocol': protocol, 'metadata': metadata, 'controls': controls, ...additionalProps } = schema;
        return new CalmRelationship(schema, uniqueId, CalmRelationshipType.deriveSchema(relationshipType), metadata ? CalmMetadata.fromSchema(metadata) : undefined, controls ? CalmControls.fromSchema(controls) : undefined, additionalProps, description, protocol);
    }
}
export class CalmRelationshipType {
    static deriveSchema(schema) {
        if (schema.interacts)
            return CalmInteractsType.fromSchema(schema.interacts);
        if (schema.connects)
            return CalmConnectsType.fromSchema(schema.connects);
        if (schema['deployed-in'])
            return CalmDeployedInType.fromSchema(schema['deployed-in']);
        if (schema['composed-of'])
            return CalmComposedOfType.fromSchema(schema['composed-of']);
        if (schema.options)
            return CalmOptionsRelationshipType.fromSchema(schema.options);
        throw new Error('Unknown relationship-type schema');
    }
}
export class CalmInteractsType extends CalmRelationshipType {
    constructor(originalJson, actor, nodes) {
        super();
        this.originalJson = originalJson;
        this.actor = actor;
        this.nodes = nodes;
        this.kind = 'interacts';
    }
    toCanonicalSchema() {
        return { interacts: { actor: this.actor, nodes: this.nodes } };
    }
    static fromSchema(schema) {
        return new CalmInteractsType(schema, schema.actor, schema.nodes);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmConnectsType extends CalmRelationshipType {
    constructor(originalJson, source, destination) {
        super();
        this.originalJson = originalJson;
        this.source = source;
        this.destination = destination;
        this.kind = 'connects';
    }
    toCanonicalSchema() {
        return { connects: { source: this.source.toCanonicalSchema(), destination: this.destination.toCanonicalSchema() } };
    }
    static fromSchema(schema) {
        return new CalmConnectsType(schema, CalmNodeInterface.fromSchema(schema.source), CalmNodeInterface.fromSchema(schema.destination));
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmDeployedInType extends CalmRelationshipType {
    constructor(originalJson, container, nodes) {
        super();
        this.originalJson = originalJson;
        this.container = container;
        this.nodes = nodes;
        this.kind = 'deployed-in';
    }
    toCanonicalSchema() {
        return { 'deployed-in': { container: this.container, nodes: this.nodes } };
    }
    static fromSchema(schema) {
        return new CalmDeployedInType(schema, schema.container, schema.nodes);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmComposedOfType extends CalmRelationshipType {
    constructor(originalJson, container, nodes) {
        super();
        this.originalJson = originalJson;
        this.container = container;
        this.nodes = nodes;
        this.kind = 'composed-of';
    }
    toCanonicalSchema() {
        return { 'composed-of': { container: this.container, nodes: this.nodes } };
    }
    static fromSchema(schema) {
        return new CalmComposedOfType(schema, schema.container, schema.nodes);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmDecisionType {
    constructor(originalJson, description, nodes, relationships, controls, metadata) {
        this.originalJson = originalJson;
        this.description = description;
        this.nodes = nodes;
        this.relationships = relationships;
        this.controls = controls;
        this.metadata = metadata;
    }
    toCanonicalSchema() {
        return {
            'description': this.description,
            'nodes': this.nodes,
            'relationships': this.relationships,
            'controls': this.controls ?? [],
            'metadata': this.metadata ?? []
        };
    }
    static fromSchema(schema) {
        return new CalmDecisionType(schema, schema.description, schema.nodes, schema.relationships, schema.controls, schema.metadata);
    }
    toSchema() {
        return this.originalJson;
    }
}
export class CalmOptionsRelationshipType extends CalmRelationshipType {
    constructor(originalJson, options) {
        super();
        this.originalJson = originalJson;
        this.options = options;
        this.kind = 'options';
    }
    toCanonicalSchema() {
        return {
            'options': this.options.map(option => option.toCanonicalSchema())
        };
    }
    static fromSchema(schema) {
        const decisions = schema.map(CalmDecisionType.fromSchema);
        return new CalmOptionsRelationshipType(schema, decisions);
    }
    toSchema() {
        return this.originalJson;
    }
}
//# sourceMappingURL=relationship.js.map